export enum PatientDisplayFormat {
  Name = 0,
  FullName = 1,
  DisplayName = 2,
  FullDisplayName = 3,
  FormalName = 4,
}
